import { Text, TouchableOpacity, View } from 'react-native';
import { styles } from '../theme';

export function AppStatusBanner({
  message,
  actionLabel,
  onAction,
}: {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <View style={styles.statusBanner} accessibilityRole="alert">
      <Text style={styles.statusBannerText}>{message}</Text>
      {actionLabel && onAction ? (
        <TouchableOpacity onPress={onAction} accessibilityRole="button">
          <Text style={styles.statusBannerAction}>{actionLabel}</Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
}
